<template lang="pug">
  .wrap.moebel-mieten
    .metanav
      .left
        router-link(:to="{ name: 'home' }") {{ $t(`Zurück zur Fundus Übersicht`) }}
        strong Fundus als Foto-, Film- und Eventlocation
    #content
      img(src="https://www.fundus.berlin/img/2013/12/HATZIUS-SCHILGEN-06-SCREEN.jpg" alt="Hatzius Schilgen")
</template>

<script>
export default {
  name: 'MoebelMieten',
  metaInfo () {
    return {
      title: 'Möbel mieten',
      meta: [
        { hid: 'description', name: 'description', content: `Möbel mieten` }
      ]
    }
  },
  data: () => ({
  }),
  computed: {
  },
  methods: {
  },
  created() {
  },
  mounted () {
    window._paq.push(['setCustomUrl', window.location])
    window._paq.push(['setDocumentTitle', this.$metaInfo.title])
    window._paq.push(['trackPageView'])
  }
}
</script>

<style scoped lang="sass">
img
  width: 100%
  height: auto
  display: block
</style>
